document.addEventListener('DOMContentLoaded', function () {
    // Product image carousel
    const productImageSwiper = new Swiper('.product-image-carousel', {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      }
    });
  
    // Gallery swiper (3 images per view)
    const gallerySwiper = new Swiper('.gallery-swiper', {
        slidesPerView: 3,
        spaceBetween: 5,
        centeredSlides: true, 
        loop: false,
        initialSlide: 1,
        breakpoints: {
            0: {
                slidesPerView: 1.5,
                centeredSlides: true,
                spaceBetween: 5,
              },
            768: {
                slidesPerView: 3,
                centeredSlides: true,
                spaceBetween: 5
            }
          }
      });
  });   
  